import React from 'react';
import SMOSpaceEditBaseFragment from './SMOSpaceEditBaseFragment';
import SMOSpaceCoverPhotoView from '../SMOSpaceCoverPhotoView';
import SMFormFieldTitle from 'components/dashboard/form/SMFormFieldTitle';
import SMFormatHelper from 'components/helpers/SMFormatHelper';
import SMFormRadio from 'components/dashboard/form/SMFormRadio';
import SMFormTextAreaWithError from 'components/dashboard/form/SMFormTextAreaWithError';
import SMFormTextFieldWithError from 'components/dashboard/form/SMFormTextFieldWithError';
import SMFormTextField from 'components/dashboard/form/SMFormTextField';
import SMFormValidationMessage from 'components/dashboard/form/SMFormValidationMessage';
import SMFormURLFieldWithError from 'components/dashboard/form/SMFormURLFieldWithError';
import SMOAcademyLinkBaloonView from 'components/dashboard/owners/SMOAcademyLinkBaloonView';
import SMConst from 'lib/SMConst';

class SMOSpaceEditBasicFragment extends SMOSpaceEditBaseFragment {
  
  constructor(props) {
    super(props);
    this.state = {
      space: this.props.space,
      isCurrent : this.isCurrent(this.props),
      errors: this.props.errors,
    };
  }
  
  componentDidMount() {
    window.addEventListener('resize', this.sizeToFit.bind(this), false);
    if (this.state.isCurrent) this.sizeToFit();
  }
  
  componentWillUnmount() {
    window.removeEventListener('resize', this.sizeToFit.bind(this), false);
  }
  
  componentWillReceiveProps(nextProps) {
    this.setState({
      isCurrent : this.isCurrent(nextProps),
      space : nextProps.space,
    });
  }
  
  render() {
    let spaceTypes = [];
    for (let i = 0; i < this.props.spaceTypes.length; i++) {
      spaceTypes.push({label:this.props.spaceTypes[i].attributes.name_text, 
                       value:this.props.spaceTypes[i].attributes.name});
    }

    return (
      <div ref="fragment" style={this.fragmentStyle()}>
        <SMOSpaceCoverPhotoView name='cover_photo' space={this.props.space} delegate={this} />

        <SMFormFieldTitle title="名称" subTitle="50文字以内。会場・建物名を入力してください。" isRequired={true} />
        <SMFormTextFieldWithError name="name"
          value={this.state.space.name}
          errorText={SMFormatHelper.errorText('Space', 'name', this.props.errors)}
          placeholderText="スペースマーケット、渋谷ビル等"
          options={{className:'w500'}}
          delegate={this} />

        <h2 className="dashboard-title mb20">
          <span className="icon-form icon-form__required">必須</span>会場の種類
        </h2>
        <SMFormRadio name="space_type"
          items={spaceTypes}
          selectedValue={this.state.space.space_type}
          options={{className:'w180'}}
          delegate={this} />

        <SMFormFieldTitle title="会場について" subTitle="10文字以上800文字以内。" isRequired={true} />
        <SMFormTextAreaWithError name="description"
          value={this.state.space.description}
          options={{className: 'form-textarea w700 h80',}}
          errorText={SMFormatHelper.errorText('Space', 'description', this.props.errors)}
          placeholderText="大きな窓から入る自然光が印象的なスタジオです。イベントやセミナーはもちろん、撮影、展示会にも利用いただけます。"
          delegate={this} />

        <h2 className="dashboard-title mb20">
          <span className="icon-form icon-form__required">必須</span>予約受付期間
          <span className="dashboard-title__supplement ml15">
            予約を受け付ける期間を設定します。開始の指定のみ必須です。半角数字のみ。
          </span>
        </h2>
        <div className="form-box">
          本日を起点として
          <SMFormTextField
            name="reservable_start"
            value={this.state.space.reservable_start}
            options={{className:"form-text w40"}}
            placeholder="1"
            delegate={this}
          /> 日先から
          <SMFormTextField
            name="reservable_duration"
            value={this.state.space.reservable_duration}
            options={{className:"form-text w40 ml5"}}
            placeholder="90"
            delegate={this}
          /> 日間予約可能とする
          <SMFormValidationMessage name='reservable_start' errorText={SMFormatHelper.errorText('Space', 'reservable_start', this.props.errors)} />
          <SMFormValidationMessage name='reservable_duration' errorText={SMFormatHelper.errorText('Space', 'reservable_duration', this.props.errors)} />
        </div>

        <h2 className="dashboard-title mb20">
          <span className="icon-form icon-form__optional">任意</span>営業時間について
        </h2>
        <SMFormTextAreaWithError name="business_hour_description"
          value={this.state.space.business_hour_description}
          errorText={SMFormatHelper.errorText('Space', 'business_hour_description', this.props.errors)}
          placeholderText="平日 9:00-21:00 土日 10:00-20:00"
          delegate={this} />


        <SMFormFieldTitle title="公開URLの設定" subTitle="URLを変更することができます。3文字から20文字まで。大小英数字とアンダーバー（_）とハイフン（-）が使用可能です。" isRequired={true} />
        <SMFormURLFieldWithError name="username"
            value={this.state.space.username}
            options={{className:'w400 ml5'}}
            errorText={SMFormatHelper.errorText('Space', 'username', this.props.errors)}
            placeholderText="spacemarket"
            delegate={this} />

        <div ref="mainTableFooter" className="js-dashboard-main-table-footer maincol-buttonarea dashboard-maincol__right-inner-100pc">
          <a href="#" className="button button-green maincol-buttonarea__button" onClick={this.didSelectNextFragment.bind(this)}>次へ</a>
        </div>
        <SMOAcademyLinkBaloonView displayPlace={SMConst.AcademyLinkDisplayPlace.SpaceBasic} isCurrent={this.state.isCurrent} />
      </div>
    );
  }
}
SMOSpaceEditBasicFragment.defaultProps = {
  errors: [],
};
export default SMOSpaceEditBasicFragment;



// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/owners/spaces/fragments/SMOSpaceEditBasicFragment.jsx